export default __webpack_public_path__ + "static/media/EM0170.34I-21080_-14940_0.13a92262.jpg";